<template>
  <ui-dialog show max-width="542px" @input="closeDialog">
    <template #header>
      <h3>{{ title }}</h3>
    </template>
    <div class="content">
      <div v-if="subtitle" v-html="subtitle"></div>
      <div v-html="description"></div>
    </div>
    <template #actions>
      <ui-button color="primary" outlined @click="closeDialog">
        {{ $t("message.common.no") }}
      </ui-button>
      <ui-button color="primary" @click="confirm">
        {{ $t(`message.common.yes`) }}
      </ui-button>
    </template>
  </ui-dialog>
</template>

<script>
export default {
  name: "AppleToggleDialog",
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String
    },
    description: {
      type: String,
      required: true
    }
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
    confirm() {
      this.$emit("confirm");
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  color: $grey-darker;
  display: flex;
  flex-direction: column;
  gap: $spacing * 2;
}
</style>
